module.exports = __webpack_public_path__ + "static/p14_gallito-f0a074c6fb11410d21f3ab41aeb75f31.png";